module.exports = __webpack_public_path__ + "img/2.cd7d5d1b.jpg";